import { useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import '../Forms.css'
import TextInput from '../FormComponents/TextInput/TextInput.js'
import {API_ROOT} from '../../AppConfig/app-config.js'
import { Alert } from 'react-bootstrap';
import LoginForm from "../Login/Login";

export default function SignUpForm() {
  const [signUp, setSignUp] = useState(false);
  const [message, setMessage] = useState(null);

  if(message !== null && signUp === true){
    return(
      <div className=" container formStyle">
        <br/>
        <Alert variant="success">
            <Alert.Heading>Your account has been created!</Alert.Heading>
            <label>{message}</label>
        </Alert>
        <LoginForm/>
      </div>
    );
  } else if(message !== null && signUp === false) {
    return (
      <div className="container formStyle">
          <Alert variant="danger">
            <Alert.Heading>Error!</Alert.Heading>
            <label>{message}</label>
          </Alert>
      </div>
    )
  } else {
    return(
      <div>
        <Formik
          initialValues={{
            firstName: "",
            lastName: "",
            email: "",
            password: ""
          }}
          validationSchema={Yup.object({
            firstName: Yup.string()
              .required("Required"),
            lastName: Yup.string()
              .required("Required"),
            email: Yup.string()
              .email("Invalid email address")
              .required("Required"),
            password: Yup.string()
              .min(8, "Password is too short")
              .max(15, "Password is too long!")
              .matches(/[a-z]/, "Password must contain at least one letter")
              .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
              .matches(/[0-9]/, "Password must contain at least one digit")
              .matches(/[!@#$%^&*]/, "Password must contain at least one special character")
              .required("Required"),
          })}
          onSubmit={
            async(values,{setSubmitting})=>{
            await new Promise(r=>setTimeout(r,500));
            fetch(`${API_ROOT}/signup`, {
              credentials: 'include',
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify(values)
            })
            .then(response => response.json()
              .then(data => ({status: response.status, returnedBody: data})))
            .then(returnedObj => {
              const strMsg = returnedObj.returnedBody.msg;
              if(returnedObj.status === 200){
                setMessage(strMsg);
                setSignUp(true);
              } else {
                setMessage(strMsg);
                setSignUp(false);
              }
            })
            .catch(error => {
              console.error("Signup error:", error);
              setMessage("Something went wrong. Please try again.");
              setSignUp(false);
            })
            .finally(() => {
              setSubmitting(false);
            });
          }}
        >
        <div className="formContainer">
          <p>Sign Up for <em>Torna Campsites</em></p>
          <hr/>
          <div className="formStyle">
            <Form>
              <TextInput
                name="firstName"
                type="text"
                placeholder="First Name"
              />
              <TextInput
                name="lastName"
                type="text"
                placeholder="Last Name"
              />
              <TextInput
                name="email"
                type="email"
                placeholder="Email Address"
              />
              <TextInput
                name="password"
                type="password"
                placeholder="Password"
              />
              <button className="buttonStyle" disabled={true} type="submit">Submit</button>
            </Form>
          </div>
          <hr/>
          <p> Please contact on mobile number 7798884419 for bookings <a href="/login"> Login</a></p>
          <p> [Note: Create user facility is not currently available, contact +91 7798884419] </p>
          <p> Already have an account?  <a href="/login"> Login</a></p>
        </div>
        </Formik>
      </div>
    );
  }
}
